<template>
  <section class="section-block">
    <div class="container">
      <div class="section-card overflow-hidden">
        <img :src="imageUrl" :alt="post.title" class="w-100" style="height: 420px; object-fit: cover;">
        <div class="p-4 p-lg-5">
          <div class="text-muted font-weight-bold mb-2">{{ formatDate(post.createdAt) }}</div>
          <h1 class="mb-4 text-primary font-weight-bold">{{ post.title }}</h1>
          <div class="rich-content" v-html="post.content"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { fetchPostBySlug } from "../../api/public";
import { resolveAssetUrl } from "../../utils/asset";
import { formatDate } from "../../utils/formatters";
import { setPageSeo } from "../../utils/seo";

export default {
  name: "NewsDetailView",
  data: function data() {
    return {
      post: {}
    };
  },
  computed: {
    imageUrl: function imageUrl() {
      return resolveAssetUrl(this.post.thumbnail);
    }
  },
  created: function created() {
    this.loadPost();
  },
  watch: {
    "$route.params.slug": function slugWatcher() {
      this.loadPost();
    }
  },
  methods: {
    formatDate,
    async loadPost() {
      const response = await fetchPostBySlug(this.$route.params.slug);
      this.post = response.data;
      const summary = this.post.summary ||
        this.post.content.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
      setPageSeo({
        title: this.post.title + " | NWM Vietnam",
        description: summary.slice(0, 160),
        path: this.$route.path
      });
    }
  }
};
</script>
